import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { StorageManager, TerminalApi } from '@atlas/core';
import { Button, Icon, Input, Label } from '@atlas/ui';

import { TERMINAL_STORAGE_KEY } from 'common/constants';

const validateSecretKeyField = value => {
  if (!value) return { message: 'terminal_initialization_popup_error_secret_key_required' };
};

const InitializationForm = ({ handleClose, setTerminalKey }) => {
  const [secretKey, setSecretKey] = useState('');
  const [isActiveInput, setIsActiveInput] = useState(false);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const changeSecretKey = useCallback(event => {
    const value = event.target.value;

    const error = validateSecretKeyField(value);

    setError(error);
    setSecretKey(value);
  }, []);

  const handleClickButton = useCallback(async () => {
    const requestData = {
      secret: secretKey,
    };

    setIsSubmitting(true);

    try {
      await TerminalApi.activateTerminal(requestData);
      StorageManager.setItem(TERMINAL_STORAGE_KEY, secretKey);
      setTerminalKey(secretKey);
      handleClose();
    } catch (error) {
      setError({ message: 'terminal_initialization_popup_error_invalid_key' });
    } finally {
      setIsSubmitting(false);
    }
  }, [secretKey, setTerminalKey, handleClose]);

  return (
    <div className="initialization-form">
      <Input
        active={isActiveInput}
        className="popup-input"
        error={error}
        label="terminal_initialization_popup_secret_key_field"
        onBlur={() => setIsActiveInput(false)}
        onChange={changeSecretKey}
        onFocus={() => setIsActiveInput(true)}
        value={secretKey}
      />
      {error && (
        <div className="help-text-container terminal-initialization-popup-error">
          <Icon
            className="terminal-initialization-popup-error-icon"
            height={24}
            name="icon-error"
            width={24}
          />
          <Label message={error.message || error.error} params={error.params} />
        </div>
      )}
      <Button
        className="primary block terminal-initialization-popup-button"
        disabled={!secretKey || isSubmitting || error}
        error={error}
        label="terminal_initialization_popup_button"
        loading={isSubmitting}
        onClick={handleClickButton}
        size="huge"
      />
    </div>
  );
};

InitializationForm.propTypes = {
  handleClose: PropTypes.func,
  setTerminalKey: PropTypes.func,
};

export default InitializationForm;
